var React = require('react');

function Readmore (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.10739 7.72474L0.107391 7.72474L1.10739 7.72474ZM6.10702 12.7248L6.1071 11.7248L6.10702 12.7248ZM19.5329 13.4328C19.9234 13.0424 19.9235 12.4092 19.533 12.0186L13.1695 5.65421C12.779 5.26365 12.1458 5.26361 11.7553 5.6541C11.3647 6.0446 11.3647 6.67776 11.7552 7.06832L17.4116 12.7256L11.7543 18.382C11.3638 18.7725 11.3637 19.4057 11.7542 19.7962C12.1447 20.1868 12.7779 20.1868 13.1684 19.7963L19.5329 13.4328ZM0.107419 0.682157L0.107391 7.72474L2.10739 7.72474L2.10742 0.682165L0.107419 0.682157ZM6.10695 13.7248L18.8257 13.7257L18.8259 11.7257L6.1071 11.7248L6.10695 13.7248ZM0.107391 7.72474C0.107378 11.0383 2.79341 13.7245 6.10695 13.7248L6.1071 11.7248C3.89807 11.7246 2.10738 9.93377 2.10739 7.72474L0.107391 7.72474Z","fill":"#00443B"}));
}

Readmore.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = Readmore;

Readmore.default = Readmore;
